import script from "./TransactionBatchView.vue?vue&type=script&setup=true&lang=js"
export * from "./TransactionBatchView.vue?vue&type=script&setup=true&lang=js"

import "./TransactionBatchView.vue?vue&type=style&index=0&id=2c60e810&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c60e810"]])

export default __exports__